import { useEffect } from "react";
import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Fordon from "@/pages/Fordon";
import FordonDetail from "@/pages/FordonDetail";
import OmOss from "@/pages/OmOss";
import HittaHit from "@/pages/HittaHit";
import Kontakt from "@/pages/Kontakt";
import Salj from "@/pages/Salj";
import Admin from "@/pages/Admin";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-ink text-slate-100 p-8 text-center">
          <div>
            <p className="font-display text-3xl font-bold mb-2">Något gick fel</p>
            <p className="text-slate-400 mb-6">Ladda om sidan för att fortsätta.</p>
            <button
              data-testid="error-reload-button"
              onClick={() => window.location.reload()}
              className="px-6 py-3 rounded-full bg-brand text-white font-medium hover:bg-brand-dark transition-colors"
            >
              Ladda om
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = window.__lenis;
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollManager />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/fordon" element={<Fordon />} />
          <Route path="/fordon/:id" element={<FordonDetail />} />
          <Route path="/om-oss" element={<OmOss />} />
          <Route path="/hitta-hit" element={<HittaHit />} />
          <Route path="/kontakt" element={<Kontakt />} />
          <Route path="/salj" element={<Salj />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
        <Footer />
        <Toaster position="bottom-right" theme="dark" richColors />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
